import styles from './StickiesLogo.module.css';

export const StickiesLogo = (props) => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect className={styles.frame} x="16.5" y="16.5" width="53" height="53"></rect>
    <rect className={styles.frame} x="28" y="28" width="53" height="53"></rect>
  </svg>
);
